// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"253":"63697c31","254":"7551eb60","432":"675689b0","630":"2a78cb6d","775":"05f67b76"}[chunkId] + ".chunk.css";
};